var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistogram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.284,
    height: 76,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37311"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17442",
    fill: "#3275ef",
    d: "M29.913 1h12v74h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17443",
    fill: "#508af3",
    d: "M17.913 22h12v53h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17445",
    fill: "#286ce9",
    d: "M41.913 33h12v42h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17446",
    fill: "#185edf",
    d: "M53.913 55h12v20h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17444",
    fill: "#6d9ffc",
    d: "M5.913 41h12v34h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21670",
    d: "M1 1v74h73.284",
    fill: "none",
    stroke: "#5e708d",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistogram);
export default __webpack_public_path__ + "static/media/Histogram.a07834d91b70adc3440068e8ecd6b8f8.svg";
export { ForwardRef as ReactComponent };